import { todayUnixUTC } from "@/constants";

export const dateStyleCSS = (date: number | null) =>
  date && date > 0 && date < todayUnixUTC
    ? "line-through text-muted-foreground"
    : "";

export const unixToDate = (unixTimestamp: number) => {
  const date = new Date(unixTimestamp);
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const formatDateAuction = (unixTimestamp: number | null) => {
  if (unixTimestamp && unixTimestamp > 0) {
    return unixToDate(unixTimestamp);
  }

  return "Data Dinâmica (site leiloeiro)";
};

export const formatDate = (date: string | Date) =>
  new Intl.DateTimeFormat("pt-BR").format(
    typeof date === "string" ? new Date(date) : date
  );

export const daysFromNow = (days: number) => {
  const todayMidnightUTC = new Date();
  todayMidnightUTC.setUTCHours(0, 0, 0, 0);
  const futureDate = new Date(todayMidnightUTC);
  futureDate.setUTCDate(futureDate.getUTCDate() + days);
  return futureDate.getTime();
};

export const daysFromPast = (days: number) => {
  const todayMidnightUTC = new Date();
  todayMidnightUTC.setUTCHours(0, 0, 0, 0);
  const pastDate = new Date(todayMidnightUTC);
  pastDate.setUTCDate(pastDate.getUTCDate() - days);
  return pastDate.getTime();
};
